/**
 * TanStack Query hooks for `kpi-threshold-triggers-cr-drop-epc-drop-fraud-spike-payout-b`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	kpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBQueryKeys,
	type CreateKpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBBody,
	type ListKpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBResponse,
	type KpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBRow,
} from "./api";

export function useKpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBList(): UseQueryResult<ListKpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBResponse, Error> {
	return useQuery({
		queryKey: kpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBQueryKeys.list(),
		queryFn: list,
	});
}

export function useKpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBCreate(): UseMutationResult<KpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBRow, Error, CreateKpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: kpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBQueryKeys.all });
		},
	});
}

export function useKpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: kpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBQueryKeys.all });
		},
	});
}
